export default "__VITE_ASSET__7e4be5ac__"